// api url (where your server is hosted at)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;



export {
  BACKEND_URL,
}
